<template>
  <componentPasswordResetExecution ref="componentPasswordResetExecution"/>
</template>
<script>
import componentPasswordResetExecution from '@/components/security/passwordResetExecution.vue';
export default {
  components: {
    componentPasswordResetExecution
  }
};
</script>
